/**
 * @generated SignedSource<<b3ec4d23a6b8e51b54e9585601950641>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewPageConversation_commentReactions$data = {
  readonly reactionsSummary?: {
    readonly ari: string;
    readonly containerAri: string;
    readonly reactionsCount: number;
    readonly reactionsSummaryForEmoji: ReadonlyArray<{
      readonly count: number;
      readonly emojiId: string;
      readonly id: string;
      readonly reacted: boolean;
    } | null>;
  } | null;
  readonly " $fragmentType": "ViewPageConversation_commentReactions";
};
export type ViewPageConversation_commentReactions$key = {
  readonly " $data"?: ViewPageConversation_commentReactions$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewPageConversation_commentReactions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "includeCommentReactions"
    },
    {
      "kind": "RootArgument",
      "name": "pageId"
    }
  ],
  "kind": "Fragment",
  "name": "ViewPageConversation_commentReactions",
  "selections": [
    {
      "condition": "includeCommentReactions",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "childType",
              "value": "comment"
            },
            {
              "kind": "Literal",
              "name": "contentType",
              "value": "page"
            },
            {
              "kind": "Variable",
              "name": "pageId",
              "variableName": "pageId"
            }
          ],
          "concreteType": "ReactionsSummaryResponse",
          "kind": "LinkedField",
          "name": "reactionsSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "ari"
            },
            {
              "kind": "ScalarField",
              "name": "containerAri"
            },
            {
              "kind": "ScalarField",
              "name": "reactionsCount"
            },
            {
              "concreteType": "ReactionsSummaryForEmoji",
              "kind": "LinkedField",
              "name": "reactionsSummaryForEmoji",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "count"
                },
                {
                  "kind": "ScalarField",
                  "name": "emojiId"
                },
                {
                  "kind": "ScalarField",
                  "name": "reacted"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Comment"
};

(node as any).hash = "8c6509fad2ffae7fb1de4666394465d8";

export default node;
